import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

function AgenciasCreate() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [t, i18n] = useTranslation("global");

  const clear = () => {
    setName("");
  };

  const saveAgencias = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_PROVEEDORES,
        {
          name,
          telefono,
          email,
          tipo:"Agencia",
          cargos:0,
          abonos:0,
          saldo:0
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Agencia",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <h3 align="center">Crea un nuevo Agencia</h3>
        <Form onSubmit={saveAgencias}>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              Agencia
            </Label>
            <Input
              type="text"
              name="email"
              
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />

            <Label for="exampleEmail" className="mr-sm-2">
              Telefono
            </Label>
            <Input
              type="text"
              name="email"
              
              value={telefono}
              required
              onChange={(e) => {
                setTelefono(e.target.value);
              }}
            />

             <Label for="exampleEmail" className="mr-sm-2">
              Email
            </Label>
            <Input
              type="text"
              name="email"
              
              value={email}
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </FormGroup>
          <Row className="container">
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                {t("Guardar")}
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                {t("Guardar")}
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="danger" href="/MenuCatalogos">
            {t("Regresar")}
            </Button>
            </Row>
        </Form>
      </div>
    </>
  );
}

export default AgenciasCreate;
